export const mutations = {
  STORE_STOCKS(state, stocks) {
    state.stocks = stocks;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/stocks/mutations.js